import { Component, OnInit, Input } from '@angular/core';
import { Helpers } from 'ngx-elvis-ds';
import { ImageHelpers } from 'src/app/base/image-helpers';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'elv-denomination-card',
  templateUrl: './denomination-card.component.html',
  styleUrls: ['./denomination-card.component.scss'],
})
export class DenominationCardComponent implements OnInit {

  @Input()
  image: string;
  imageUrl: string;

  @Input()
  isCoin: boolean;

  constructor(
    private configSvc: ConfigService
  ) { }

  ngOnInit() {
    this.imageUrl = ImageHelpers.getImageURL('denomination-images/eur/png', this.image, this.configSvc);
  }

}
